import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { UserListComponent } from './users/userList/user-list.component';
import { PermissionListComponent } from './permissions/permisionList/permission-list.component';
import { RolesListsComponent } from './roless/roleLists/roles-lists.component';
import { OrganizationListsComponent } from './organizations/orgnisationLists/organization-lists.component';
import { ModuleListsComponent } from './moduleMasters/moduleLists/module-lists.component';
import { LoginDetailsComponent } from './login-details/login-details.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path:'',
        component: UserListComponent,
      },
      {
        path:'permissions',
        component: PermissionListComponent
      },
      {
        path:'role',
        component: RolesListsComponent
      },
      {
        path:'organization',
        component: OrganizationListsComponent
      },
      {
        path:'module',
        component: ModuleListsComponent
      },
      {
        path:'logindetails',
        component: LoginDetailsComponent
      }
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class adminRoutingModule { }
